import buzzfeedPageAssets from './buzzfeed';
import cabifyPageAssets from './cabify';
import cookPadAssets from './cookpad';
import deliverooPageAssets from './deliveroo';
import designMuseumAssets from './designmuseum';
import enterpriseAssets from './enterprise';
import hudlPageAssets from './hudl';
import laboratoriaAssets from './laboratoria';
import modePageAssets from './mode';
import monzoPageAssets from './monzo';
import nokiaPageAssets from './nokia';
import yieldrPageAssets from './yieldr';
import securityAssets from './security';
import trusonaPageAssets from './trusona';
import zincAssets from './zinc';

const assets = {
  buzzfeed: buzzfeedPageAssets,
  cabify: cabifyPageAssets,
  cookpad: cookPadAssets,
  deliveroo: deliverooPageAssets,
  designMuseum: designMuseumAssets,
  enterprise: enterpriseAssets,
  hudl: hudlPageAssets,
  security: securityAssets,
  laboratoria: laboratoriaAssets,
  mode: modePageAssets,
  monzo: monzoPageAssets,
  nokia: nokiaPageAssets,
  yieldr: yieldrPageAssets,
  trusona: trusonaPageAssets,
  zinc: zincAssets,
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/index.js